import React from "react";
import { Link } from "react-router-dom";
import ADNavbar from "../components/ADNavbar";
import SiteFooter from "../components/SiteFooter";
import { siteConfig, initiativesContent } from "../data/mock";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

const InitiativeShell = ({ item }) => (
  <>
    <ADNavbar />
    <section className="pt-28 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
          <ArrowLeft size={12} /> Back
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <span className={`text-[10px] tracking-wider uppercase px-2 py-0.5 border ${
            item.status === "Active" ? "text-gray-700 border-gray-400" : "text-gray-400 border-gray-200"
          }`}>{item.status}</span>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          {item.title}
        </h1>

        <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
          {item.fullContent.split("\n\n").map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        {item.link && (
          <a href={item.link} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 mt-8 text-xs text-gray-500 border border-gray-200 px-5 py-2.5 hover:border-gray-400 hover:text-gray-700 transition-all">
            Visit on Facebook <ArrowUpRight size={10} />
          </a>
        )}
      </div>
    </section>
    <SiteFooter />
  </>
);

export const AmberAlertPage = () => {
  const item = initiativesContent.items.find(i => i.title === "Social Media Amber Alert");
  return (
    <>
      <ADNavbar />
      <section className="pt-28 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
            <ArrowLeft size={12} /> Back
          </Link>

          <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 border text-gray-700 border-gray-400 mb-2 inline-block">Active</span>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 mt-2" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            {item.title}
          </h1>

          {/* Facebook screenshot — floated right */}
          <div className="float-right ml-8 mb-6 w-52 hidden md:block">
            <div className="border border-gray-100 p-1 rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/6j39ybfe_image.png"
                alt="Social Media Amber Alert Facebook Page"
                className="w-full h-auto rounded-sm"
              />
            </div>
            <p className="text-[10px] text-gray-300 mt-2 text-center">647 followers on Facebook</p>
          </div>

          <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
            {item.fullContent.split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="clear-both" />

          {/* Mobile image */}
          <div className="mt-8 mb-8 w-64 mx-auto md:hidden">
            <div className="border border-gray-100 p-1 rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/6j39ybfe_image.png"
                alt="Social Media Amber Alert Facebook Page"
                className="w-full h-auto rounded-sm"
              />
            </div>
          </div>

          {item.link && (
            <a href={item.link} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 mt-8 text-xs text-gray-500 border border-gray-200 px-5 py-2.5 hover:border-gray-400 hover:text-gray-700 transition-all">
              Visit on Facebook <ArrowUpRight size={10} />
            </a>
          )}
        </div>
      </section>
      <footer className="py-10 px-6 border-t border-gray-100">
        <div className="max-w-3xl mx-auto">
          <p className="text-gray-400 text-xs">{siteConfig.copyright}</p>
        </div>
      </footer>
    </>
  );
};

export const TeamHustlePage = () => {
  const item = initiativesContent.items.find(i => i.title.includes("Team Hustle"));
  const [form, setForm] = React.useState({ name: "", email: "", experience: "", message: "" });
  const [sent, setSent] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: "", email: "", experience: "", message: "" });
    setTimeout(() => setSent(false), 5000);
  };

  return (
    <>
      <ADNavbar />
      <section className="pt-28 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
            <ArrowLeft size={12} /> Back
          </Link>

          <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 border text-gray-700 border-gray-400 mb-2 inline-block">Active</span>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 mt-2" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            {item.title}
          </h1>

          {/* Team Hustle photo — smaller, floated */}
          <div className="float-right ml-6 mb-4 w-56 border border-gray-100 p-1">
            <img
              src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/s6456m18_image.png"
              alt="Team Hustle - We Create Champions"
              className="w-full h-auto"
            />
          </div>

          {/* Main content */}
          <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
            {item.fullContent.split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="clear-both" />

          {/* Results & Proof */}
          <div className="mt-14 pt-10 border-t border-gray-100">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              Results & Proof
            </h2>
            <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
              <p>This isn't based on theory—it's built on outcomes.</p>
              <p>The individuals mentored under Team Hustle don't just improve—they produce at levels that separate them from their peers. Across multiple dealerships and sales environments, mentees have consistently:</p>
              <ul className="space-y-2 pl-1">
                <li className="flex gap-2"><span className="text-gray-400">•</span> Reached top producer status within their locations</li>
                <li className="flex gap-2"><span className="text-gray-400">•</span> Increased income from average earnings to six figures and beyond</li>
                <li className="flex gap-2"><span className="text-gray-400">•</span> Maintained consistent month-over-month performance, not short-term spikes</li>
                <li className="flex gap-2"><span className="text-gray-400">•</span> Developed the ability to close at will, regardless of market conditions</li>
              </ul>
              <p>This isn't luck. It's structure, discipline, and execution.</p>
              <p className="italic text-gray-700">There's a reason the same names stay at the top.</p>
            </div>
          </div>

          {/* Apply for Mentorship */}
          <div className="mt-14 pt-10 border-t border-gray-100">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              Apply for Mentorship
            </h2>
            <div className="text-gray-500 text-sm leading-[1.9] space-y-5 mb-10">
              <p>This is not an open program.</p>
              <p>Adris Davis does not work with everyone—and that's intentional.</p>
              <p>This mentorship is reserved for individuals who:</p>
              <ul className="space-y-2 pl-1">
                <li className="flex gap-2"><span className="text-gray-400">•</span> Are already in sales and serious about scaling their income</li>
                <li className="flex gap-2"><span className="text-gray-400">•</span> Understand that results require discipline, not motivation</li>
                <li className="flex gap-2"><span className="text-gray-400">•</span> Are willing to be coached, corrected, and held accountable</li>
                <li className="flex gap-2"><span className="text-gray-400">•</span> Want to operate at a level where performance becomes expected</li>
              </ul>
              <p>If you're looking for shortcuts, this is not for you.<br />If you're ready to produce at an elite level, you'll fit right in.</p>
              <p className="text-xs text-gray-400 uppercase tracking-wider">Limited availability. Select placements only.</p>
            </div>

            {/* Application form */}
            <form onSubmit={handleSubmit} className="space-y-5 max-w-lg">
              <div>
                <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1.5">Name</label>
                <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-0 py-2 border-0 border-b border-gray-200 text-sm text-gray-900 focus:outline-none focus:border-gray-400 bg-transparent transition-colors" required />
              </div>
              <div>
                <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1.5">Email</label>
                <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full px-0 py-2 border-0 border-b border-gray-200 text-sm text-gray-900 focus:outline-none focus:border-gray-400 bg-transparent transition-colors" required />
              </div>
              <div>
                <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1.5">Current Role & Experience</label>
                <input type="text" value={form.experience} onChange={(e) => setForm({ ...form, experience: e.target.value })}
                  placeholder="e.g. Sales Consultant, 3 years"
                  className="w-full px-0 py-2 border-0 border-b border-gray-200 text-sm text-gray-900 placeholder-gray-300 focus:outline-none focus:border-gray-400 bg-transparent transition-colors" required />
              </div>
              <div>
                <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1.5">Why Team Hustle?</label>
                <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={3}
                  className="w-full px-0 py-2 border-0 border-b border-gray-200 text-sm text-gray-900 focus:outline-none focus:border-gray-400 bg-transparent resize-none transition-colors" required />
              </div>
              <button type="submit" className="text-sm text-gray-900 border border-gray-900 px-8 py-2.5 tracking-wider uppercase hover:bg-gray-900 hover:text-white transition-all duration-300">
                Apply
              </button>
            </form>
            {sent && <p className="mt-4 text-sm text-gray-500">Application received. We'll be in touch.</p>}
          </div>
        </div>
      </section>
      <footer className="py-10 px-6 border-t border-gray-100">
        <div className="max-w-3xl mx-auto">
          <p className="text-gray-400 text-xs">{siteConfig.copyright}</p>
        </div>
      </footer>
    </>
  );
};

export const NightOwlPage = () => {
  const [form, setForm] = React.useState({ name: "", email: "", business: "" });
  const [sent, setSent] = React.useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: "", email: "", business: "" });
    setTimeout(() => setSent(false), 5000);
  };

  return (
    <>
      <ADNavbar />
      {/* Dark hero banner */}
      <section className="pt-20" style={{ backgroundColor: "#141414" }}>
        <div className="max-w-6xl mx-auto px-6 py-16 lg:py-24">
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            {/* Logo */}
            <div className="lg:w-5/12 flex-shrink-0">
              <img
                src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/tlq0aa53_image.png"
                alt="Night Owl Entrepreneurs"
                className="w-full max-w-sm mx-auto h-auto"
              />
            </div>
            {/* Intro */}
            <div className="lg:w-7/12">
              <p className="text-[11px] tracking-[0.3em] uppercase mb-4" style={{ color: "#C9972D" }}>Initiative</p>
              <h1
                className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-[1.1]"
                style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
              >
                Night Owl Entrepreneurs
              </h1>
              <p className="text-sm leading-[1.9] mb-6" style={{ color: "rgba(255,255,255,0.5)" }}>
                Built for the ones who refuse to operate on average timelines.
              </p>
              <p className="text-sm leading-[1.9]" style={{ color: "rgba(255,255,255,0.4)" }}>
                Night Owl Entrepreneurs is a collective of individuals who understand that success isn't built during comfort hours—it's built when others are asleep.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content sections */}
      <section className="py-20 px-6" style={{ backgroundColor: "#1a1a1a" }}>
        <div className="max-w-3xl mx-auto">
          <div className="space-y-12">
            {/* Who it's for */}
            <div>
              <p className="text-sm leading-[1.9] mb-5" style={{ color: "rgba(255,255,255,0.45)" }}>
                This initiative was created for entrepreneurs, builders, and operators who:
              </p>
              <div className="space-y-2.5 pl-1">
                {["Stay up late refining ideas", "Push forward when most people shut down", "Operate with urgency, discipline, and intention"].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: "#C9972D" }} />
                    <p className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>{item}</p>
                  </div>
                ))}
              </div>
              <p className="text-sm italic mt-6" style={{ color: "rgba(255,255,255,0.35)" }}>
                This isn't networking. This is a think tank.
              </p>
            </div>

            {/* What it represents */}
            <div>
              <h2 className="text-xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
                What Night Owl Represents
              </h2>
              <div className="space-y-2.5 pl-1">
                {[
                  ["Execution over talk", "ideas mean nothing without movement"],
                  ["Accountability at a high level", "no excuses, no hiding"],
                  ["Collaboration", "building alongside like-minded individuals"],
                  ["Consistency", "daily grind, regardless of circumstance"],
                ].map(([bold, rest], i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 rounded-full flex-shrink-0 mt-1.5" style={{ backgroundColor: "#C9972D" }} />
                    <p className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>
                      <span className="text-white font-medium">{bold}</span> – {rest}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* The Culture */}
            <div>
              <h2 className="text-xl font-bold text-white mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
                The Culture
              </h2>
              <p className="text-sm leading-[1.9] mb-5" style={{ color: "rgba(255,255,255,0.45)" }}>
                Night Owl Entrepreneurs is built on one core belief:
              </p>
              <p className="text-base font-medium text-white italic mb-8" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
                "The people who win are the ones who keep going when everyone else stops."
              </p>
              <p className="text-sm leading-[1.9] mb-4" style={{ color: "rgba(255,255,255,0.45)" }}>
                This is where entrepreneurs come to:
              </p>
              <div className="space-y-2.5 pl-1">
                {[
                  "Develop real business ideas",
                  "Push through stagnation",
                  "Surround themselves with others operating at a high level",
                  "Build a brotherhood and sisterhood rooted in growth and results",
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: "#C9972D" }} />
                    <p className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>{item}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Join */}
            <div className="pt-8 border-t" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
                Join the Movement
              </h2>
              <p className="text-sm leading-[1.9] mb-8" style={{ color: "rgba(255,255,255,0.4)" }}>
                This is not for spectators. If you're serious about building, executing, and surrounding yourself with people who demand more—you belong here.
              </p>

              <form onSubmit={handleSubmit} className="space-y-5 max-w-md">
                <div>
                  <label className="block text-[10px] uppercase tracking-[0.2em] mb-1.5" style={{ color: "rgba(255,255,255,0.3)" }}>Name</label>
                  <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full px-0 py-2 border-0 border-b text-sm text-white bg-transparent focus:outline-none transition-colors"
                    style={{ borderColor: "rgba(255,255,255,0.1)" }}
                    onFocus={(e) => e.target.style.borderColor = "#C9972D"}
                    onBlur={(e) => e.target.style.borderColor = "rgba(255,255,255,0.1)"}
                    required />
                </div>
                <div>
                  <label className="block text-[10px] uppercase tracking-[0.2em] mb-1.5" style={{ color: "rgba(255,255,255,0.3)" }}>Email</label>
                  <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className="w-full px-0 py-2 border-0 border-b text-sm text-white bg-transparent focus:outline-none transition-colors"
                    style={{ borderColor: "rgba(255,255,255,0.1)" }}
                    onFocus={(e) => e.target.style.borderColor = "#C9972D"}
                    onBlur={(e) => e.target.style.borderColor = "rgba(255,255,255,0.1)"}
                    required />
                </div>
                <div>
                  <label className="block text-[10px] uppercase tracking-[0.2em] mb-1.5" style={{ color: "rgba(255,255,255,0.3)" }}>What Are You Building?</label>
                  <input type="text" value={form.business} onChange={(e) => setForm({ ...form, business: e.target.value })}
                    className="w-full px-0 py-2 border-0 border-b text-sm text-white bg-transparent focus:outline-none transition-colors"
                    style={{ borderColor: "rgba(255,255,255,0.1)" }}
                    onFocus={(e) => e.target.style.borderColor = "#C9972D"}
                    onBlur={(e) => e.target.style.borderColor = "rgba(255,255,255,0.1)"}
                    required />
                </div>
                <button type="submit"
                  className="text-sm font-semibold px-10 py-3 tracking-wider uppercase transition-all duration-300"
                  style={{ backgroundColor: "#C9972D", color: "#fff" }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#b8882a"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "#C9972D"}>
                  Join Night Owl
                </button>
              </form>
              {sent && <p className="mt-4 text-sm" style={{ color: "#C9972D" }}>Application received. Welcome to the grind.</p>}
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
    </>
  );
};

export const FeedingCommunityPage = () => (
  <>
    <ADNavbar />
    <section className="pt-28 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
          <ArrowLeft size={12} /> Back
        </Link>

        <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 border text-gray-700 border-gray-400 mb-2 inline-block">Active</span>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 mt-2" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          Feeding the Community
        </h1>

        {/* Two-column: Image left, text right */}
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          <div className="lg:w-5/12 flex-shrink-0">
            <div className="border border-gray-100 p-1.5 overflow-hidden group">
              <img
                src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/zasixlrr_image.png"
                alt="Feeding the Community"
                className="w-full h-auto transition-transform duration-700 group-hover:scale-[1.03]"
              />
            </div>
          </div>

          <div className="lg:w-7/12 text-gray-500 text-sm leading-[1.9] space-y-5">
            <p>This initiative wasn't created for recognition.<br />It was created from a place of love—and it continues to grow from that same place today.</p>
            <p>Whether it's pulling up to a drive-thru and purchasing 50 to 60 meals at a time, or putting together simple goody bags to hand out directly, the mission is simple:</p>
            <p className="text-gray-900 font-medium italic" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Do something. Every time.</p>
            <p>There's no waiting for the perfect moment. No overcomplication. Just action.</p>
          </div>
        </div>

        {/* Where It Comes From */}
        <div className="mt-16 pt-12 border-t border-gray-100">
          <h2 className="text-xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            Where It Comes From
          </h2>
          <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
            <p>Giving back isn't something Adris Davis adopted—it's something he was raised in.</p>
            <p>Guided by family, this work is rooted in example:</p>
            <div className="space-y-3 pl-1">
              <div className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-gray-300 flex-shrink-0 mt-2" />
                <p>His father, a Marine, made sure programs like Toys for Tots always had enough to reach every child possible</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-gray-300 flex-shrink-0 mt-2" />
                <p>His mother, an evangelist, leads It's All About Jesus Street Ministry, serving families for years with food, clothing, and support throughout their community</p>
              </div>
            </div>
            <p>This foundation created a mindset that giving isn't optional—it's responsibility.</p>
          </div>
        </div>

        {/* The Belief */}
        <div className="mt-16 pt-12 border-t border-gray-100">
          <h2 className="text-xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            The Belief
          </h2>
          <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
            <p>This initiative is driven by one core principle:</p>
            <p className="text-gray-900 font-medium italic text-base" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>If you have the ability to help, you help.</p>
            <p>No spotlight needed. No conditions attached.</p>
            <p>Just consistent action, rooted in faith, built on discipline, and carried forward through purpose.</p>
          </div>
        </div>

        {/* Ongoing Impact */}
        <div className="mt-16 pt-12 border-t border-gray-100">
          <h2 className="text-xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            Ongoing Impact
          </h2>
          <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
            <p>What started small has continued to expand over the years—reaching more people, more families, and more moments where help was needed.</p>
            <p>Because at the end of the day, it's not about scale.</p>
            <p className="text-gray-900 font-medium italic" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>It's about showing up.</p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 pt-12 border-t border-gray-100">
          <p className="text-sm text-gray-500 mb-6">Want to support or get involved?</p>
          <Link to="/contact"
            className="text-sm text-gray-900 border border-gray-900 px-8 py-2.5 tracking-wider uppercase hover:bg-gray-900 hover:text-white transition-all duration-300 inline-block">
            Get in Touch
          </Link>
        </div>
      </div>
    </section>
    <SiteFooter />
  </>
);

export const CarsForFamiliesPage = () => {
  const item = initiativesContent.items.find(i => i.title.includes("Cars for Families"));
  return (
    <>
      <ADNavbar />
      <section className="pt-28 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
            <ArrowLeft size={12} /> Back
          </Link>

          <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 border text-gray-700 border-gray-400 mb-2 inline-block">Active</span>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 mt-2" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            {item.title}
          </h1>

          {/* Car image — floated right */}
          <div className="float-right ml-8 mb-6 w-56 hidden md:block">
            <div className="border border-gray-100 p-1 rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/oj5c7ugn_image.png"
                alt="Cars for Families Initiative"
                className="w-full h-auto rounded-sm"
              />
            </div>
            <p className="text-[10px] text-gray-300 mt-2 text-center">20+ vehicles donated since 2020</p>
          </div>

          <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
            {item.fullContent.split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="clear-both" />

          {/* Mobile image */}
          <div className="mt-8 mb-4 w-64 mx-auto md:hidden">
            <div className="border border-gray-100 p-1 rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/oj5c7ugn_image.png"
                alt="Cars for Families Initiative"
                className="w-full h-auto rounded-sm"
              />
            </div>
          </div>
        </div>
      </section>
      <footer className="py-10 px-6 border-t border-gray-100">
        <div className="max-w-3xl mx-auto">
          <p className="text-gray-400 text-xs">{siteConfig.copyright}</p>
        </div>
      </footer>
    </>
  );
};

export const PTCPage = () => (
  <>
    <ADNavbar />
    <section className="pt-28 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
          <ArrowLeft size={12} /> Back
        </Link>
        <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 border text-gray-700 border-gray-400 mb-2 inline-block">Active</span>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 mt-2" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          Prestigious Travel Club Foundation
        </h1>
        <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
          <p>A 501(c)(3) non-profit organization built on service—supporting military families, feeding communities, and rewarding donors with premium travel certificates.</p>
          <p>The foundation was built from a background rooted in military service and ministry—two paths that instill discipline, compassion, and an unwavering commitment to others. Giving is not something we do occasionally—it's who we are.</p>
          <p>We give every single month to St. Jude Children's Research Hospital, Children's Miracle Network Hospitals, and the Wounded Warrior Project. Beyond national organizations, we actively support our communities by providing food to families in need and being present where help is needed most.</p>
        </div>
      </div>
    </section>
    <SiteFooter />
  </>
);

export const SpeakingPage = () => (
  <>
    <ADNavbar />
    <section className="pt-28 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
          <ArrowLeft size={12} /> Back
        </Link>
        <span className="text-[10px] tracking-wider uppercase px-2 py-0.5 border text-gray-600 border-gray-300 mb-2 inline-block">Available</span>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 mt-2" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          Speaking & Workshops
        </h1>
        <div className="text-gray-500 text-sm leading-[1.9] space-y-5">
          <p>Adris Davis is available for speaking engagements, corporate workshops, and mentorship sessions focused on sales mastery, entrepreneurship, and leadership development.</p>
          <p>With over two decades of experience leading high-performance teams and building businesses from the ground up, Adris brings a direct, no-nonsense approach to every stage and every room.</p>
          <p>Topics include elite sales tactics, the psychology of the buyer, building a business with no money, credit mastery, and developing a production-driven mindset.</p>
        </div>
        <Link to="/contact" className="inline-flex items-center gap-1.5 mt-8 text-xs text-gray-500 border border-gray-200 px-5 py-2.5 hover:border-gray-400 hover:text-gray-700 transition-all">
          Get in Touch
        </Link>
      </div>
    </section>
    <SiteFooter />
  </>
);
